import { COLOR_KEYS, NORMAL_VARIANT_STYLES, VARIANT_STYLE_MAPPING } from "../constants";
import { normalizeKeys } from "./";
const CONTAINER_SPACING_KEYS = {
    ROOT: "root",
    NESTED: "nested",
    ARTICLE: "article",
};
const ROOT_SECTION_STYLES = "py-[80px] px-[16px] lg:py-[128px] ";
const NESTED_SECTION = "py-[40px] px-[8px] lg:py-[64px]";
const CONTAINER_SPACING = {
    root: ROOT_SECTION_STYLES,
    nested: NESTED_SECTION,
    article: "py-[0px] px-[0px] lg:py-[0px]",
};
const STYLE_KEYS = {
    TEXT_ALIGNMENT: "textAlignment",
    TEXT_ALIGNMENT_MOBILE: "mobileTextAlignment",
    TITLE_SPACING: "sectionTitleSpacing",
    TITLE_COLOR: "sectionTitleColor",
    CONTENT_COLOR: "sectionContentColor",
    CONTAINER_SPACING: "containerSpacing",
};
const STYLE_VALUES = {
    TEXT_CENTERED: "Center",
    TEXT_LEFT: "Left",
    TEXT_RIGHT: "Right",
    SPACING_NORMAL: "64px",
    SPACING_SMALL: "32px",
    SPACING_X_SMALL: "0px",
    // Add more mappings as needed
};
const SECTION_STYLE_KEYS = [STYLE_KEYS.CONTAINER_SPACING];
const DESCRIPTION_STYLE_KEYS = [STYLE_KEYS.TEXT_ALIGNMENT, STYLE_KEYS.TEXT_ALIGNMENT_MOBILE, STYLE_KEYS.CONTENT_COLOR];
const HEADER_STYLE_KEYS = [
    STYLE_KEYS.TEXT_ALIGNMENT,
    STYLE_KEYS.TEXT_ALIGNMENT_MOBILE,
    STYLE_KEYS.TITLE_SPACING,
    STYLE_KEYS.TITLE_COLOR,
];
const OMITTED_KEYS = ["title"];
export const getBGfromVariant = (variant) => {
    switch (variant) {
        case COLOR_KEYS.PRIMARY_BLUE:
        case "primary":
            return "bg-is2-blue";
        case COLOR_KEYS.LIGHT_YELLOW:
        case "light":
            return "bg-is2-yellow-100";
        case COLOR_KEYS.LIGHT_BLUE:
        case "info":
            return "bg-is2-blue-50";
        case COLOR_KEYS.LIGHT_GREEN:
        case "green":
        case "dark":
            return "bg-is2-green-50";
        case COLOR_KEYS.WHITE:
        case "normal":
            return "bg-white";
        case COLOR_KEYS.DARK_BLUE:
            return "bg-is2-blue-500";
        case "No background color":
        default:
            return "";
    }
};
// const formatStylingObject = (styling: SectionStylingObject): FormattedStylingObject => {
const formatStylingObject = (styling) => {
    return {
        descriptionStyling: styling.descriptionStyling.join(" "),
        headerStyling: styling.headerStyling.join(" "),
        imageStyling: styling.imageStyling.join(" "),
        sectionStyling: styling.sectionStyling.join(" "),
        textColor: styling.textColor || "text-is2-gray-900",
        wrapperColor: styling.wrapperColor || "bg-white",
        inverseColor: styling.inverseColor || "bg-white",
    };
};
export const getContentBlockStyling = (contentStyling, contentBlockBackgroundColor = COLOR_KEYS.WHITE) => {
    const { fields: sectionStyling } = contentStyling !== null && contentStyling !== void 0 ? contentStyling : { fields: {} };
    const { WRAPPER_COLOR, TEXT_COLOR, INVERSE_COLOR } = VARIANT_STYLE_MAPPING[contentBlockBackgroundColor] || NORMAL_VARIANT_STYLES;
    if (!sectionStyling || Object.keys(sectionStyling).length === 0) {
        const styling = {
            descriptionStyling: [],
            headerStyling: [],
            imageStyling: [],
            sectionStyling: [],
        };
        styling.sectionStyling.push(WRAPPER_COLOR);
        styling.headerStyling.push(TEXT_COLOR);
        styling.textColor = TEXT_COLOR;
        styling.wrapperColor = WRAPPER_COLOR;
        styling.inverseColor = INVERSE_COLOR;
        const sectionWrapper = getClassName(STYLE_KEYS.CONTAINER_SPACING, CONTAINER_SPACING_KEYS.ROOT);
        styling.sectionStyling.push(sectionWrapper);
        return formatStylingObject(styling);
    }
    const formattedSectionStyling = Object.entries(sectionStyling).reduce((acc, [key, value]) => {
        if (OMITTED_KEYS.includes(key)) {
            return acc;
        }
        const className = getClassName(key, value);
        if (DESCRIPTION_STYLE_KEYS.includes(key)) {
            acc.descriptionStyling.push(className);
        }
        if (HEADER_STYLE_KEYS.includes(key)) {
            acc.headerStyling.push(className);
        }
        if (SECTION_STYLE_KEYS.includes(key)) {
            acc.sectionStyling.push(className);
        }
        return acc;
    }, {
        descriptionStyling: [],
        headerStyling: [],
        imageStyling: [],
        sectionStyling: [],
    });
    formattedSectionStyling.sectionStyling.push(WRAPPER_COLOR);
    formattedSectionStyling.headerStyling.push(TEXT_COLOR);
    formattedSectionStyling.textColor = TEXT_COLOR;
    formattedSectionStyling.wrapperColor = WRAPPER_COLOR;
    formattedSectionStyling.inverseColor = INVERSE_COLOR;
    return formatStylingObject(formattedSectionStyling);
};
const STYLE_KEY_TO_CLASS = {
    [STYLE_KEYS.TEXT_ALIGNMENT]: "md:text",
    [STYLE_KEYS.TEXT_ALIGNMENT_MOBILE]: "text",
    [STYLE_KEYS.TITLE_SPACING]: "pb",
    [STYLE_KEYS.TITLE_COLOR]: "text",
    [STYLE_KEYS.CONTENT_COLOR]: "text",
    // Add more mappings as needed
};
const STYLE_VALUE_TO_CLASS = {
    [STYLE_VALUES.TEXT_CENTERED]: "center",
    [STYLE_VALUES.TEXT_LEFT]: "left",
    [STYLE_VALUES.TEXT_RIGHT]: "right",
    [STYLE_VALUES.SPACING_NORMAL]: "16",
    [STYLE_VALUES.SPACING_SMALL]: "8",
    [STYLE_VALUES.SPACING_X_SMALL]: "[0px]",
    gray: "is2-black-20",
    "light gray": "is2-gray-300",
    "tertiary gray": "is2-gray-body",
    black: "black",
    white: "white",
    // Add more mappings as needed
};
/*
    Preset styles are styles that map directly to a set of classes without needing to combine key-value pair
*/
const PRESET_STYLE_KEYS = [STYLE_KEYS.CONTAINER_SPACING];
const getClassName = (styleKey, styleValue) => {
    if (PRESET_STYLE_KEYS.includes(styleKey)) {
        /* For now the only preset key is container spacing
        Configure a map when there are more
        */
        return CONTAINER_SPACING[normalizeKeys(styleValue)] || "";
    }
    const baseClass = STYLE_KEY_TO_CLASS[styleKey];
    const subClass = STYLE_VALUE_TO_CLASS[styleValue];
    if (baseClass && subClass) {
        return `${baseClass}-${subClass}`;
    }
    return "";
};
